import { URL_PLACEHOLDER } from "../constants";

export const attachQueryParams = (url: string, params: Record<string, string | number | null | undefined>): string => {
    if (!url) return "";

    const [baseLink, restLink] = url.split(URL_PLACEHOLDER);
    const link = decodeURIComponent(restLink);
    const queryParams = Object.entries(params)
        .filter(([, value]) => value !== null && value !== undefined && value !== "") // Remove empty values
        .map(([key, value]) => `${key}=${value}`)
        .join("&");

    const fullQueryParamStr = `${link}${link.includes("?") ? "&" : "?"}${queryParams}`;
    return `${baseLink}${URL_PLACEHOLDER}${encodeURIComponent(queryParams ? fullQueryParamStr : "")}`;
};
